export default {
  FETCH_DATA: 'parking_cont_fetch_data',
  UPDATE_QUERY: 'parking_cont_update_query',
  LOAD_MORE_DATA: 'parking_cont_load_more_data',
  UPDATE_LOADING: 'parking_cont_update_loading',
  UPDATE_SELECTED: 'parking_cont_update_selected',
  UPDATE_ACTIVE_DETAIL: 'parking_cont_active_detail',
};
